import { Moment } from 'moment';

export const getStartOfMonth = (date: Moment): Moment => {
    return date.clone().startOf('month');
};

export const getEndOfMonth = (date: Moment): Moment => {
    return date.clone().endOf('month');
};
